import { render, staticRenderFns } from "./send_sms.vue?vue&type=template&id=38eded2e&scoped=true&"
import script from "./send_sms.vue?vue&type=script&lang=js&"
export * from "./send_sms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eded2e",
  null
  
)

export default component.exports